import React from 'react';
import styled from 'styled-components';
import { Text } from '../../../../components';
import { COLORS } from '../../../../constants';

interface DivProps extends React.HTMLProps<HTMLDivElement> {
  txt: string;
}

export const AchElement: React.FC<DivProps> = ({ txt, children, ...props }) => {
  return (
    <ElementStyle {...props}>
      <Text size={22} color={COLORS.BLACK} text={txt} />
    </ElementStyle>
  );
};

const ElementStyle = styled.div`
  padding-top: 20px;
  border-top: 1px solid ${COLORS.RED_LINE};
  display: flex;
  align-content: flex-start;
`;
